import { DropdownMenuItem, DropdownMenuLabel } from '@/components/ui/dropdown-menu';
import { DropletsIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Budget, useBudgets } from '@liquidbudget/common';

interface Props {
  budget?: Budget;
}

export function BudgetSwitcherBudgets({ budget }: Props) {
  const budgets = useBudgets();

  if (budgets.length === 0) {
    return null;
  }

  return (
    <>
      <DropdownMenuLabel className="text-xs text-muted-foreground"> Budgets</DropdownMenuLabel>
      {budgets.map((b) => (
        <DropdownMenuItem key={b.id} disabled={budget?.id === b.id} asChild>
          <Link to={`/budget/${b.id}`} className="flex items-center gap-2">
            <div className="flex size-6 items-center justify-center">
              <DropletsIcon className="size-4 shrink-0" />
            </div>
            {b.name}
          </Link>
        </DropdownMenuItem>
      ))}
    </>
  );
}
